// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useState} from 'react';
import cn from 'classnames';
import {Link, useHistory} from 'react-router-dom';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_arrow_right from '../../img/icons/16/arrow_right.svg';
import Icon_triangle_down from '../../img/icons/16/triangle_down.svg';
import {use_region_countries} from './use_region_countries';
import styles from './locations.module.less';

interface i_location_props {
    region: string;
    on_toggle?: ()=>void;
}
export const Location = (props: i_location_props)=>{
    const {region, on_toggle} = props;
    const history = useHistory();
    const {theme} = use_theme({def: 'oculus'});
    const {count, data, name, to} = use_region_countries(region, 5);
    const [expanded, set_expanded] = useState(false);
    const on_region_click = ()=>{
        if (!on_toggle)
            history.push(to);
        else
        {
            set_expanded(v=>!v);
            setTimeout(()=>{ on_toggle(); }, 0);
        }
    };
    return <div className={cn(styles.location, expanded && styles.expanded)}
      onClick={on_region_click}>
      <div className={styles.title}>
        <p className={cn(theme.p14, theme.semi, styles.region)}>
          {name} <Icon_triangle_down className={styles.icon}/></p>
        <p className={cn(theme.p12, styles.count)}>
          {count?.toLocaleString()} proxies</p>
      </div>
      <div className={styles.list_wrapper}>
        <div className={styles.list}>
          {data.map(c=>{
            return <Link className={styles.list_item} key={c.name} to={c.to}
              onClick={ev=>ev.stopPropagation()}>
              <span className={cn(theme.P, theme.p14, theme.med)}>
                {c.name}</span>
              <span className={cn(theme.P, theme.p12)}>
                {c.count?.toLocaleString()} proxies</span>
            </Link>;
          })}
          <Link className={styles.list_item} to={to}>
            <span className={cn(theme.P, theme.p14, theme.med)}>
              See all</span> <Icon_arrow_right/>
          </Link>
        </div>
      </div>
    </div>;
};

const regions = ['Popular', 'Europe', 'Northern America', 'South America',
    'Asia', 'Africa'];

interface i_locations_menu_props {
    on_toggle?: ()=>void;
}
export const Locations_menu = (props: i_locations_menu_props)=>{
    const {on_toggle} = props;
    return <div className={styles.locations_menu}>
      {regions.map((reg, index)=>{
        return <Fragment key={reg}>
          <Location region={reg} on_toggle={on_toggle}/>
          {index<regions.length-1 && <div className={styles.separator}/>}
        </Fragment >;
      })}
    </div>;
};
